import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  background-color: #FFEDE6;
  border-radius: 50px;
  padding: 4px 24px 4px 4px;
  width: fit-content;
  gap: 16px;
`;

export const IconContainer = styled.div`
    width: 50px;
    height: 50px;
    background-color: #FF4A01;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-weight: 600;
    font-size: 18px;
    cursor: pointer;
`;

export const Text = styled.span`
  color: #1f2937;
  font-weight: 500;
  font-size: 16px;
  white-space: nowrap;
`;
